import http from '../common/http-auth'


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const exportBillingReport = async(clientId: number, fromDate: string, toDate: string) => {
    const response = http.get(`/report/billingreport?clientId=${clientId}&fromDate=${fromDate}&toDate=${toDate}`)
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const getAlltestemailsendhistory = async (
  clientId: number,
  source? : string,
  sourceId?: number,
  fromDate?: string,
  toDate?: string
) => {
  let query = `/report/testemailsendhistory?clientId=${clientId}`;

  if ((source != null) && source.trim() !== "") {
    query += `&source=${encodeURIComponent(source.trim())}`;
  }
  if ((sourceId != null) && sourceId !== 0) {
    query += `&sourceId=${sourceId}`;
  }

  if (fromDate != null) {
    query += `&fromDate=${fromDate}`;
  }

  if (toDate != null) {
    query += `&toDate=${toDate}`;
  }

  return http.get(query);
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const exportBounceReport = async (
    clientId: number,
    campaignType:string,
    campaignId?: number,
    fromDate?: string,
    toDate?: string
  ) => {
    const params = new URLSearchParams();
  
    params.append('clientId', clientId.toString());
    params.append('campaignType', campaignType);

    if (campaignId !== undefined && campaignId !== 0) {
      params.append('campaignId', campaignId.toString());
    }
  
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (fromDate) {
      params.append('fromDate', fromDate);
    }
  
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (toDate) {
      params.append('toDate', toDate);
    }
  
    const response = http.get(`/report/bouncereport?${params.toString()}`);
    return response;
  };
